<ps-ui-card>
  <h6 psCardHeader>AVG CPI</h6>

  <div psCardContent class="survey-status">
    <div class="content-status">
      <button class="stats-menu-btn" [psUiDropdownToggleFor]="Cpi">
        {{ content.cpi1Label }}
      </button>
      <ps-ui-dropdown class="status-dropdown" #Cpi="psUiDropdown">
        <button
          *ngIf="userRole === 'buyer' || userRole === 'operator'"
          psUiDropdownItem
          (click)="
            content.cpi1Label = 'Projected';
            content.cpi1Value = content.cpi.projected
          "
        >
          Projected
        </button>
        <button
          psUiDropdownItem
          (click)="
            content.cpi1Label = 'At Launch';
            content.cpi1Value = content.cpi.launch
          "
        >
          At Launch
        </button>
        <button
          psUiDropdownItem
          (click)="
            content.cpi1Label = 'Current';
            content.cpi1Value = content.cpi.current
          "
        >
          Current
        </button>
      </ps-ui-dropdown>
    </div>
    <div class="content-status">|</div>
    <div class="content-status">
      <button class="stats-menu-btn" [psUiDropdownToggleFor]="Acpi">
        {{ content.cpi2Label }}
      </button>
      <ps-ui-dropdown class="status-dropdown" #Acpi="psUiDropdown">
        <button
          psUiDropdownItem
          (click)="
            content.cpi2Label = 'At Launch';
            content.cpi2Value = content.cpi.launch
          "
        >
          At Launch
        </button>
        <button
          *ngIf="userRole === 'buyer' || userRole === 'operator'"
          psUiDropdownItem
          (click)="
            content.cpi2Label = 'Projected';
            content.cpi2Value = content.cpi.projected
          "
        >
          Projected
        </button>
        <button
          psUiDropdownItem
          (click)="
            content.cpi2Label = 'Current';
            content.cpi2Value = content.cpi.current
          "
        >
          Current
        </button>
      </ps-ui-dropdown>
    </div>
  </div>

  <div psCardFooter class="cpi-footer">
    <div class="content-status w-80">
      <span>{{
        content.cpi1Label === 'Current' && content.is_qbp_enable
          ? 'QBP'
          : (content.cpi1Value | currency : content.currencySymbol)
      }}</span>
    </div>
    <div class="content-status">|</div>
    <div class="content-status w-80">
      <span>{{
        content.cpi2Label === 'Current' && content.is_qbp_enable
          ? 'QBP'
          : (content.cpi2Value | currency : content.currencySymbol)
      }}</span>
    </div>
  </div>
</ps-ui-card>
